//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'hero-aside-list-item',
  props: {
    title: {
      type: String,
      required: true,
    },
    scrollTo: {
      type: String,
      required: true,
    },
    totalCount: {
      type: Number,
      default: null,
    },
  },
};
